import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import tooltip from 'simple-tooltip';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/todo-assignee-cell.scss';

Component('tr-grid-todo-assignee-cell', {
  mixins: [baseMixin],

  properties: {
    showAssigneeName: {
      type: Boolean,
      default: false,
    },
    hideResultText: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
      observer(editable) {
        if (this.editorInitialized && this.editor) {
          this.editor.disabled = !editable;
        }
      },
    },
  },

  connected() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      mouseover: this.handleAssigneeMouseover.bind(this),
      mouseout: this.handleAssigneeMouseout.bind(this),
      'tr-todo-assignee-select-field:change': this.handleChange.bind(this),
      'tr-selector-field-list:opened': () => { this.editing = true; },
      'tr-selector-field-list:closed': () => { this.editing = false; },
    });
  },

  preventClickEvent({ target }) {
    return this.editable
      && closest(target, '.tr-todo-assignee-select-field', this);
  },

  handleClick({ target }) {
    const field = closest(target, '.tr-todo-assignee-select-field', this);
    if (field && !field.classList.contains('grid-cell-editor')) {
      this.beginEditing();
    }
  },

  async beginEditing() {
    if (!this.editable || this.editing) return;

    await this.prepareEditor();
    if (!this.editor) return;

    this.editor.toggleList(true);
  },

  setValue(value) {
    this.value = value;

    if (this.editorInitialized) {
      this.editor.setValue(value);
    } else {
      this.prepareEditor();
    }
  },

  prepareEditor() {
    return new Promise(async (resolve) => {
      if (this.editorInitialized) {
        resolve();
      } else {
        this.editor = await this.editorLoader.editor;
        this.editorInitialized = true;
        if (!this.editor) {
          resolve();
          return;
        }

        if (this.value) {
          const selectedOption = this.editor
            .querySelector(`select option[value="${this.value}"]`);
          if (selectedOption) selectedOption.selected = true;
        }

        this.listenTo(this.editor, 'tao:ready', resolve, { once: true });
        this.replaceChild(this.editor, this.firstElementChild);
      }
    });
  },

  handleChange(event) {
    this.value = event.detail;
    this.namespacedTrigger('cellValueChange', {
      detail: { value: event.detail },
      bubbles: true,
    });
  },

  toggleMinimalStatus(minimal) {
    this.editable = !minimal;
    this.hideResultText = minimal;
  },

  handleAssigneeMouseover(event) {
    const result = closest(event.target, '.selector-field-result');
    if (!result || !this.hideResultText || this.showAssigneeName) return;

    const assigneeResult = result.querySelector('.selected-text');
    if (!assigneeResult || assigneeResult.hasAttribute('data-no-assignee')) return;

    if (this.tooltipHovering) {
      this.tooltipHovering = false;
      return;
    }

    $('.simple-tooltip').remove();

    this.tooltip = tooltip({
      el: result,
      content: assigneeResult.querySelector('.text').textContent,
      position: 'top',
    });
    this.tooltip.el.addClass('todo-item-assignee-tooltip');

    this.tooltip.show();
  },

  handleAssigneeMouseout(event) {
    if (event.relatedTarget
      && closest(event.relatedTarget, '.todo-item-assignee-tooltip')) {
      this.tooltipHovering = true;
    }

    if (!this.showAssigneeName) this.destroyAssigneeTooltip();
  },

  destroyAssigneeTooltip() {
    if (this.tooltip) {
      this.tooltip.destroy();
      this.tooltip = null;
    }
  },
});
